import { useCandidateAuth } from 'features/auth/AuthProvider';
import { SignInToContinuePage } from 'features/auth/ui';
import { useAnalytics } from 'modules/analytics';
import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { TenantProvider } from 'shared/contexts';
import { useActualizeTenantLanguage, useFetchTenant } from 'shared/hooks';

function RouteGuard() {
    const { status, accessToken } = useCandidateAuth();
    const tenantContextValue = useFetchTenant();

    const { tenant } = tenantContextValue;

    useAnalytics(tenant);
    useActualizeTenantLanguage(tenant);

    const hasAnyToken = accessToken.token || accessToken.oldAvailabilityToken;

    if (status === 'unauthorized' && !hasAnyToken) {
        return (
            <SignInToContinuePage variant="firstTime" />
        );
    }

    if (!tenant || status === 'pendingSilent' && !hasAnyToken) {
        return null;
    }

    return (
        <TenantProvider value={ tenantContextValue }>
            <Outlet />
        </TenantProvider>
    );
}

export default memo(RouteGuard);
